import { FC, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthContext } from '@/providers';
import { AccessDeniedModal } from './AccessDeniedModal';

// ==============================|| ADMINISTRATION SCOPE GATE ||============================== //
// Complementul de SCOPARE al PermissionGate: rolurile de administrație (fsp) pot
// deschide doar paginile administrațiilor PROPRII — accesul direct pe URL către altă
// administrație (sau către crearea uneia noi, rută fără :id) primește modalul
// Forbidden, ca la lipsa de permisiune. Scoparea reală a datelor rămâne în BE
// (CTZ-2693) — gate-ul e doar apărarea din UI.

export const AdministrationScopeGate: FC<{ children: ReactNode }> = ({ children }) => {
	const { id } = useParams<{ id: string }>();
	const { user } = useAuthContext();

	if (user?.role !== 'fsp') return <>{children}</>;

	const ownIds = (
		(user as unknown as { administrations?: { id: number }[] })?.administrations ?? []
	).map((a) => a.id);
	return ownIds.includes(Number(id)) ? <>{children}</> : <AccessDeniedModal open />;
};
